import Main from './pages/Main'
import Trips from "./pages/Trips";
import Tickets from "./pages/Tickets";
import Data from "./pages/Data";
import Payment from "./pages/Payment";
import SmsForm from "./pages/SmsForm";
import QrSection from "./pages/QrSection";

const routes = [
    {
        path: '/',
        component: Main,
        name: 'web'
    },
    {
        path: '/web-trips/:from/:to/:date',
        component: Trips,
        name: 'web-trips'
    },
    {
        path: '/web-tickets/:from/:to/:date/:id',
        component: Tickets,
        name: 'web-tickets'
    },
    {
        path: '/web-data',
        component: Data,
        name: 'web-data'
    },
    {
        path: '/web-payment',
        component: Payment,
        name: 'web-payment'
    },
    {
        path: '/web-sms',
        component: SmsForm,
        name: 'web-sms'
    },
    {
        path: '/web-qr-code',
        component: QrSection,
        name: 'web-qr-code'
    }
];

export default routes;
